"use client";

/**
 * Ver o trilho em 3D: a trail's flyover (montanhas-admin-web#4), the camera
 * following the route over the relief, recorded in the back-office as a video.
 * A tile with a frame of it that opens the video alone in the gallery's player,
 * muted and looping, since it has no sound. Nothing for a trail without one.
 * The trail's popup and A minha inscrição's trail card use it.
 */
import { Play } from "lucide-react";
import { cdnUrl } from "@/lib/cdn";
import { track } from "@/lib/analytics";
import type { Photo, TrailFlyover } from "@/lib/types/event";
import { openGallery } from "@/components/event/EventGallery";

export function FlyoverTile({ flyover, trailId, className = "" }: { flyover: TrailFlyover | null | undefined; trailId: number; className?: string }) {
  if (!flyover) {
    return null;
  }
  const open = () => {
    track("trail_flyover", { trail_id: String(trailId) });
    const video: Photo = {
      id: -trailId,
      path: flyover.url,
      thumbnail: flyover.thumbnail,
      width: flyover.width,
      height: flyover.height,
      video: true,
      loop: true,
    };
    openGallery([video], 0);
  };
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        open();
      }}
      className={`pressable flex w-full items-center gap-3 overflow-hidden rounded-[10px] border border-line bg-surface p-1.5 pr-3 text-left ${className}`}
    >
      <span
        className="relative flex h-14 w-20 shrink-0 items-center justify-center overflow-hidden rounded-[7px] bg-line bg-cover bg-center"
        style={flyover.thumbnail ? { backgroundImage: `url('${cdnUrl(flyover.thumbnail)}')` } : undefined}
      >
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-black/55 text-white backdrop-blur-sm">
          <Play size={13} fill="currentColor" className="translate-x-px" />
        </span>
      </span>
      <span className="min-w-0">
        <b className="block text-[14px] font-bold leading-tight">Ver o trilho em 3D</b>
        <small className="block text-[12.5px] text-ink-soft">O percurso sobre o relevo, do início ao fim</small>
      </span>
    </button>
  );
}
